import * as Sentry from '@sentry/gatsby'

const IGNORED_GQL_ERRORS = [
  'Invalid username or password',
  'Your card was declined',
  'User already exists with email',
  'Coupon not found',
]

// This should actually be called "formatGqlError" as this
// does not handle general gatsby errors
export const formatError = (err) => {
  if (process.env.GATSBY_ENVIRONMENT != 'production') {
    console.error(err)
  }
  const asString = String(err?.message ?? err ?? '')

  if (!IGNORED_GQL_ERRORS.some(s => asString.includes(s))) {
    Sentry.captureException(err instanceof Error ? err : new Error(asString))
  }

  return asString.replace(/^(GraphQL error:\s*)/i, '')
}
